import { FormProvider } from 'react-hook-form';
import { useUserBulkCreation } from './hooks';
import { UserBulkCreationPresentation } from './presentations';

type Props = {
  /** モーダルを閉じるコールバック */
  onClose: () => void;
  /** 一括追加成功時のコールバック */
  onSuccess: () => void;
};

export const UserBulkCreation: React.FC<Props> = ({ onClose, onSuccess }) => {
  const {
    state: { methods, registrationType, isConfirmDisabled },
    actions: { handleSubmit, handleDownloadCsvTemplate, handleDownloadCsvTemplateSjis },
  } = useUserBulkCreation({ onSuccess });

  return (
    <FormProvider {...methods}>
      <UserBulkCreationPresentation
        title='利用者の一括追加・更新'
        registrationType={registrationType}
        isConfirmDisabled={isConfirmDisabled}
        showGuideAlert={true}
        showNewRegistrationLabels={true}
        onClose={onClose}
        onConfirm={handleSubmit}
        onDownloadCsvTemplate={handleDownloadCsvTemplate}
        onDownloadCsvTemplateSjis={handleDownloadCsvTemplateSjis}
      />
    </FormProvider>
  );
};
